import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import CookieRain from "../components/decorations/CookieRain";

import Header from "../components/Header";
import Footer from "../components/Footer";

import Home from "../pages/home/Home";
import PageBySlug from "./PageBySlug";
import CreateDecoration from "../components/decorations/CreateDecoration";
import EditDecoration from "../components/decorations/EditDecoration";
import AdminDecorationList from "../components/decorations/AdminDecorationList";

import WorkDetail from "../pages/works/WorkDetail";
import LaDupla from "../pages/laDupla/LaDupla";
import LadoB from "../pages/ladoB/LadoB";

import Signup from "../pages/admin/Signup";
import Login from "../pages/admin/Login";
import Dashboard from "../pages/admin/dashboard/Dashboard";
import AdminWorkList from "../pages/admin/lists/AdminWorkList";
import AdminBProjectList from "../pages/admin/lists/AdminBProjectList";

import CreateWork from "../pages/works/api/CreateWork";
import EditWork from "../pages/works/api/EditWork";
import WorksReorderPage from "../pages/admin/reorder/WorksReorderPage";

import CreateB from "../pages/ladoB/api/CreateBProject";
import EditB from "../pages/ladoB/api/EditBProject";
import BProjectsReorderPage from "../pages/admin/reorder/BProjectsReorderPage";

import CreateTeam from "../pages/laDupla/api/CreateTeam";
import EditTeam from "../pages/laDupla/api/EditTeam";

import CreatePage from "../pages/admin/api/CreatePage";
import EditPage from "../pages/admin/api/EditPage";

import Protected from "../pages/admin/Protected";
import ScrollToTop from "../components/ScrollToTop";

import { AuthProvider } from "../auth/AuthProvider";
import { SiteProvider } from "./SiteProvider";

import UnderConstruction from "../pages/construccion/UnderConstruction";
import PublicGate from "./PublicGate";

function AppRouter() {
  return (
    <AuthProvider>
      <SiteProvider>
        <Router>
          <ScrollToTop />

          <Routes>
            <Route path="en-construccion" element={<UnderConstruction />} />

            <Route element={<PublicGate />}>

              <Route element={<MainLayout />}>

                <Route index element={ <PageBySlug key="home" forcedSlug="home" render={page => <Home page={page} />} /> } />

                <Route path="la-dupla" element={ <PageBySlug key="la-dupla" forcedSlug="la-dupla" render={page => <LaDupla page={page} />} /> } />
                <Route path="lado-b" element={ <PageBySlug key="lado-b" forcedSlug="lado-b" render={page => <LadoB page={page} />} /> } />

                <Route path="trabajos/:slug" element={<WorkDetail />} />
                <Route path="admin/login" element={<Login />} />

                <Route element={<Protected />}>
                  <Route path="admin/signup" element={<Signup />} />
                  <Route path="admin/dashboard" element={<Dashboard />} />
                  
                  <Route path="/admin/works" element={<AdminWorkList />} />
                  <Route path="/admin/b" element={<AdminBProjectList />} />

                  <Route path="admin/work/create" element={<CreateWork />} />
                  <Route path="admin/work/edit/:id" element={<EditWork />} />
                  <Route path="admin/work/reorder" element={<WorksReorderPage />} />

                  <Route path="admin/decoration/create" element={<CreateDecoration />} />
                  <Route path="admin/decoration/edit/:id" element={<EditDecoration />} />

                  <Route path="admin/team/create" element={<CreateTeam />} />
                  <Route path="admin/team/edit/:id" element={<EditTeam />} />
                  <Route path="admin/decorations" element={<AdminDecorationList />} />

                  <Route path="admin/b/create" element={<CreateB />} />
                  <Route path="admin/b/edit/:id" element={<EditB />} />
                  <Route path="admin/b/reorder" element={<BProjectsReorderPage />} />

                  <Route path="admin/page/create" element={<CreatePage />} />
                  <Route path="admin/page/edit" element={<EditPage />} />
                </Route>

              </Route>

            </Route>

          </Routes>

        </Router>
      </SiteProvider>
    </AuthProvider>
  );
}

function MainLayout() {
  const [cookieTrigger, setCookieTrigger] = useState(0);

  const handleCookieClick = () => {
    setCookieTrigger(prev => prev + 1);
  };

  return (
    <>
      <CookieRain trigger={cookieTrigger} />
      <Header />
      <Outlet />
      <Footer onCookieClick={handleCookieClick} />
    </>
  );
}

export default AppRouter;
